/** Default page size for Track Translations tables. */
export const TRACK_PAGE_SIZE = 50;

/**
 * UI string constants for the Track Translations feature.
 * Centralizes all user-facing text for maintainability and future i18n.
 */

export const TRACK_STRINGS = {
  PAGE_TITLE: 'Track Translations',
  PAGE_DESCRIPTION:
    'Monitor the status of all your current and historical translation jobs.',

  ERROR_ACTIVE_HEADER: 'Error loading active jobs',
  ERROR_HISTORICAL_HEADER: 'Error loading historical jobs',
  ERROR_BODY:
    'Something went wrong while fetching translation data. Please try again later or contact the LangHub team if the problem persists.',

  ACTIVE_JOBS_HEADER: 'Jobs Currently Under Translation',
  ACTIVE_JOBS_SUBTITLE:
    '(This table only has the groups currently being translated)',
  ACTIVE_JOBS_LOADING: 'Loading active jobs',
  ACTIVE_JOBS_EMPTY_TITLE: 'No active jobs',
  ACTIVE_JOBS_EMPTY_BODY:
    'No in-progress translation jobs found for the selected filters.',

  HISTORICAL_JOBS_HEADER: 'Historical Jobs',
  HISTORICAL_JOBS_SUBTITLE:
    '(This table has completed, failed, and cancelled job details)',
  HISTORICAL_JOBS_LOADING: 'Loading historical jobs',
  HISTORICAL_JOBS_EMPTY_TITLE: 'No historical jobs',
  HISTORICAL_JOBS_EMPTY_BODY:
    'No completed translation jobs found for the selected filters.',
} as const;
